/**
 * Utility functions for managing pinned asset types
 */

/**
 * Sort asset options with pinned items at the top
 * @param {Array} options - Asset type options
 * @param {Array} pinnedTypes - List of pinned asset types
 * @returns {Object} { pinned, unpinned } arrays
 */
export const sortAssetsByPin = (options, pinnedTypes = []) => {
  if (!options || options.length === 0) {
    return { pinned: [], unpinned: [] };
  }

  const pinned = [];
  const unpinned = [];

  options.forEach((option) => {
    const optionValue = typeof option === 'string' ? option : option.value;
    if (pinnedTypes.includes(optionValue)) {
      pinned.push(option);
    } else {
      unpinned.push(option);
    }
  });

  // Sort pinned by the order in pinnedTypes
  pinned.sort((a, b) => {
    const aValue = typeof a === 'string' ? a : a.value;
    const bValue = typeof b === 'string' ? b : b.value;
    return pinnedTypes.indexOf(aValue) - pinnedTypes.indexOf(bValue);
  });

  return { pinned, unpinned };
};

/**
 * Get pin icon and styling
 * @param {boolean} isPinned - Whether the item is pinned
 * @returns {Object} { icon, className }
 */
export const getPinStyles = (isPinned) => {
  return {
    icon: isPinned ? '📌' : '📍',
    className: isPinned ? 'text-indigo-600' : 'text-gray-400',
  };
};

export default {
  sortAssetsByPin,
  getPinStyles,
};
